import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

export default function ServiceInitialFields({ value = {}, onChange }) {
  return <Row className="g-3 mb-3">
    <Col md={6}><Form.Group controlId="service-solicitare">
      <Form.Label className="fw-bold">Solicitare inițială client</Form.Label>
      <Form.Control as="textarea" rows={5} placeholder="Simptome și lucrări cerute de client"
        value={value.solicitare || ''} onChange={e => onChange({ ...value, solicitare: e.target.value })} />
    </Form.Group></Col>
    <Col md={6}><Form.Group controlId="service-constatare">
      <Form.Label className="fw-bold">Constatarea inițială</Form.Label>
      <Form.Control as="textarea" rows={5} placeholder="Defecțiuni constatate și intervenții propuse"
        value={value.constatare || ''} onChange={e => onChange({ ...value, constatare: e.target.value })} />
    </Form.Group></Col>
  </Row>;
}
